import { Context, Effect } from "effect";
import type { Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { ExplorerAction, ExplorerSnapshot, RegistrationSettlement } from "./model.ts";

export interface DatabaseExplorerSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<ExplorerSnapshot>>;
  readonly settlements: Effect.Effect<readonly RegistrationSettlement[]>;
  readonly dispatch: (action: ExplorerAction) => Effect.Effect<void>;
}
export class DatabaseExplorerSessions extends Context.Service<DatabaseExplorerSessions, {
  readonly open: Effect.Effect<DatabaseExplorerSession, never, Scope.Scope>;
}>()("workerstation/frontend/DatabaseExplorerSessions") {}
